import React from "react"
import { Box, Container, Text, Heading, Grid } from "@theme-ui/components"

import { InboundLink } from "../link"
import { getPagePath } from "../../utils/path"
import { i18nContext } from "../../context/i18nContext"
import BareContactForm from "./bareContactForm"

const ContactForm = ({ block }) => {
  const {
    title,
    subtitle,
    description,
    contactPage = true,
    link,
    alternateLayout = false,
  } = block

  console.log("BLOCK", block)

  return (
    <Box
      sx={{
        py: alternateLayout ? [2, 2] : [4, 6],
        backgroundColor: contactPage ? "transparent" : "primary",
      }}
    >
      <i18nContext.Consumer>
        {t => (
          <>
            <Container name="contactForm">
              <Box>
                <Grid
                  columns={
                    alternateLayout ? [1, 1, "2fr 4fr"] : [1, 1, "4fr 4fr"]
                  }
                >
                  <Box
                    sx={{
                      maxWidth: "559px",
                    }}
                  >
                    {title && (
                      <Heading
                        as="h2"
                        variant="h1"
                        sx={{
                          my: [4],
                          marginBottom: [0],
                          color: "primary",
                          fontSize: alternateLayout ? [4, 6] : [6, 8],
                          fontWeight: "body",
                          letterSpacing: "-.5px",
                          lineHeight: "1.12",
                        }}
                      >
                        {title}
                      </Heading>
                    )}
                    {subtitle && (
                      <Heading
                        as="h3"
                        variant="h3"
                        sx={{
                          color: contactPage ? "dark" : "light",
                          fontWeight: 300,
                          my: alternateLayout ? [0, 2] : [0, 4],
                          fontSize: alternateLayout ? [2, 3] : [3, 4],
                        }}
                      >
                        {subtitle}
                      </Heading>
                    )}
                    <Text
                      as="div"
                      variant="sectionTitle"
                      sx={{
                        my: [0, 4],
                        color: contactPage ? "dark" : "light",
                        fontSize: [3],
                        fontWeight: 300,
                        letterSpacing: "-.5px",
                        lineHeight: "1.12",
                        em: {
                          fontStyle: "normal",
                          color: contactPage ? "dark" : "light",
                        },
                      }}
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                    {link && (
                      <InboundLink to={getPagePath(link.link, link.locale)}>
                        {link.anchor}
                      </InboundLink>
                    )}
                  </Box>
                  <BareContactForm
                    contactPage={contactPage}
                    alternateLayout={alternateLayout}
                  />
                </Grid>
              </Box>
            </Container>
          </>
        )}
      </i18nContext.Consumer>
    </Box>
  )
}

export default ContactForm
